/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Пагинация
 * @export
 * @interface GetList200ResponsePagination
 */
export interface GetList200ResponsePagination {
  /**
   *
   * @type {number}
   * @memberof GetList200ResponsePagination
   */
  totalRecords: number
  /**
   *
   * @type {number}
   * @memberof GetList200ResponsePagination
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof GetList200ResponsePagination
   */
  perPage: number
  /**
   *
   * @type {number}
   * @memberof GetList200ResponsePagination
   */
  lastPage: number
}

/**
 * Check if a given object implements the GetList200ResponsePagination interface.
 */
export function instanceOfGetList200ResponsePagination(
  value: object
): value is GetList200ResponsePagination {
  if (!('totalRecords' in value) || value['totalRecords'] === undefined)
    return false
  if (!('page' in value) || value['page'] === undefined) return false
  if (!('perPage' in value) || value['perPage'] === undefined) return false
  if (!('lastPage' in value) || value['lastPage'] === undefined) return false
  return true
}

export function GetList200ResponsePaginationFromJSON(
  json: any
): GetList200ResponsePagination {
  return GetList200ResponsePaginationFromJSONTyped(json, false)
}

export function GetList200ResponsePaginationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetList200ResponsePagination {
  if (json == null) {
    return json
  }
  return {
    totalRecords: json['totalRecords'],
    page: json['page'],
    perPage: json['perPage'],
    lastPage: json['lastPage'],
  }
}

export function GetList200ResponsePaginationToJSON(
  value?: GetList200ResponsePagination | null
): any {
  if (value == null) {
    return value
  }
  return {
    totalRecords: value['totalRecords'],
    page: value['page'],
    perPage: value['perPage'],
    lastPage: value['lastPage'],
  }
}
